<template>
  <layout>
    <page-header :header="$t('settings.title')" :header-small="section.name" />
    <form ref="form" class="content settings-columns" @submit.prevent="submit">
      <b-card>
        <fields />
      </b-card>
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
    </form>
  </layout>
</template>


<script>
import find from 'lodash-es/find'
import { FormMixin } from 'stylemix-base'
import { mapState } from 'vuex'

export default {
  name: 'SettingForm',

  mixins: [FormMixin],

  data: () => ({
    model: {},
    groups: {},
  }),

  computed: {
    ...mapState('settings', {
      sections: (state) => state.sections,
    }),

    section() {
      const current = find(this.sections, { key: this.$route.params.section })
      return current || {}
    },
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    loadForm() {
      this.$uiBlocker(
        this.$http
          .get(`admin-settings/sections/${this.$route.params.section}`)
          .then(({ data }) => {
            this.model = data.data.length !== undefined ? {} : data.data
            this.groups = data.groups
            this.setFields(data.fields)
          }),
        this.$refs.form
      )
    },

    submit() {
      this.$uiBlocker(
        this.$http
          .post(
            this.section?.options?.submit_url ||
              `admin-settings/sections/${this.$route.params.section}`,
            this.formData()
          )
          .then((response) => {
            this.$toast.success(response.data.message)
          }),
        this.$refs.form
      )
    },

    formData() {
      let formData = new FormData()
      this.fields.all().forEach((field) => {
        field.appendFormData(formData, this.model)
      })
      return formData
    },
  },
}
</script>
